import { WebApiService } from './plugins/webApiService';
import AuthPlugin from './plugins/authPlugin';
import { IUserResponse } from './plugins/authPlugin';
import AccountService from './RunPay/Admin/Services/AccountService';
import AgentListDocumentOptionService from './RunPay/Admin/Services/AgentListDocumentOptionService';
import ContractService from './RunPay/Admin/Services/ContractService';
import KpiService from './RunPay/Admin/Services/KpiService';
import MainSliderService from './RunPay/Admin/Services/MainSliderService';
import MapService from './RunPay/Admin/Services/MapService';
import NewsService from './RunPay/Admin/Services/NewsService';
import PartnersService from './RunPay/Admin/Services/PartnersService';
import SeoService from './RunPay/Admin/Services/SeoService';
import ShopService from './RunPay/Admin/Services/ShopService';
import UserMobileService from './RunPay/Admin/Services/UserMobileService';
import VacancyService from './RunPay/Admin/Services/VacancyService';
import WsCallbacks from './WebSocketControllers/Core/WsCallbacks'

export default class ApiDataSource {
	webApiService: WebApiService;
	private authPlugin: AuthPlugin;
	AccountService: AccountService;
	AgentListDocumentOptionService: AgentListDocumentOptionService;
	ContractService: ContractService;
	KpiService: KpiService;
	MainSliderService: MainSliderService;
	MapService: MapService;
	NewsService: NewsService;
	PartnersService: PartnersService;
	SeoService: SeoService;
	ShopService: ShopService;
	UserMobileService: UserMobileService;
	VacancyService: VacancyService;
	WsCallbacks: WsCallbacks;
	constructor(webApiUrl: string) {
		this.webApiService = new WebApiService(webApiUrl);
		this.AccountService = new AccountService(this.webApiService);
		this.AgentListDocumentOptionService = new AgentListDocumentOptionService(this.webApiService);
		this.ContractService = new ContractService(this.webApiService);
		this.KpiService = new KpiService(this.webApiService);
		this.MainSliderService = new MainSliderService(this.webApiService);
		this.MapService = new MapService(this.webApiService);
		this.NewsService = new NewsService(this.webApiService);
		this.PartnersService = new PartnersService(this.webApiService);
		this.SeoService = new SeoService(this.webApiService);
		this.ShopService = new ShopService(this.webApiService);
		this.UserMobileService = new UserMobileService(this.webApiService);
		this.VacancyService = new VacancyService(this.webApiService);
		this.WsCallbacks = new WsCallbacks(this.webApiService);
		// плагин авторизации
		this.authPlugin = new AuthPlugin(this.AccountService);
	}

	public get User(): IUserResponse {
		return this.authPlugin.User;
	}
	public get isLoggedIn(): boolean {
		return this.authPlugin.isLoggedIn;
	}
	public SetUser(user: IUserResponse) {
		this.authPlugin.setUser(user);
	}
}



// WEBPACK FOOTER //
// ./scripts/dataSource/api/apiDataSource.ts